/**
 * @param {string} key Message catalog key, e.g. `core.errors.invalidProjectFile`
 * @param {Record<string, unknown>} [params]
 */
export function createCoreError(key, params) {
  const error = new Error(key);
  error.name = "CoreError";
  error.key = key;
  if (params) {
    error.params = params;
  }
  return error;
}

/**
 * @param {unknown} error
 * @returns {error is Error & { key: string, params?: Record<string, unknown> }}
 */
export function isCoreError(error) {
  return Boolean(
    error
    && typeof error === "object"
    && error.name === "CoreError"
    && typeof error.key === "string",
  );
}
